/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function GrabberVertical({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M5.75 2.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M5.75 6.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M5.75 11.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M10.25 2.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M10.25 6.9a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2M10.25 11.4a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2" /></svg>;
}
;